import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-cobalt text-parchment pt-32 pb-12 overflow-hidden relative">
      {/* Decorative Topographical Background */}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-topo-pattern"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mb-24 pb-16 border-b border-parchment/10">
          
          <div className="lg:col-span-5">
            <a href="#" className="font-serif text-4xl font-bold tracking-tighter flex items-center gap-3 mb-8 text-white">
              <SafeIcon icon={FiIcons.FiCompass} className="text-amber" />
              NomadCrate
            </a>
            <p className="max-w-md text-parchment/60 font-light text-lg leading-relaxed mb-10">
              Equipping the modern explorer with modular systems for seamless global transitions. We believe travel is the ultimate workspace.
            </p>
            
            <div className="space-y-4">
              <p className="text-[10px] font-black uppercase tracking-[0.4em] text-amber">Join the Dispatch</p>
              <div className="flex max-w-sm">
                <input 
                  type="email" 
                  placeholder="Explorer Email" 
                  className="bg-white/5 border-none text-parchment px-6 py-4 w-full focus:ring-1 focus:ring-amber text-sm font-light"
                />
                <button className="bg-amber text-white px-8 py-4 hover:bg-amber-dark transition-colors">
                  <SafeIcon icon={FiIcons.FiArrowRight} />
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-black uppercase tracking-[0.3em] text-[10px] mb-8 text-amber">Systems</h4>
            <ul className="space-y-4 text-parchment/50 text-sm font-medium">
              <li><a href="#" className="hover:text-white transition-colors">The Full Global</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Compression Core</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Tech Archive</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Sanitary Pouch</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Hardware Kits</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-black uppercase tracking-[0.3em] text-[10px] mb-8 text-amber">Company</h4>
            <ul className="space-y-4 text-parchment/50 text-sm font-medium">
              <li><a href="#" className="hover:text-white transition-colors">Our Philosophy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">The Archive</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Support Hub</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Deployment Map</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Returns</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-black uppercase tracking-[0.3em] text-[10px] mb-8 text-amber">Connect</h4>
            <div className="grid grid-cols-2 gap-4">
              <a href="#" className="flex items-center gap-3 text-parchment/50 hover:text-white transition-colors text-xs font-bold uppercase tracking-widest">
                <SafeIcon icon={FiIcons.FiInstagram} /> Instagram
              </a>
              <a href="#" className="flex items-center gap-3 text-parchment/50 hover:text-white transition-colors text-xs font-bold uppercase tracking-widest">
                <SafeIcon icon={FiIcons.FiTwitter} /> Twitter
              </a>
              <a href="#" className="flex items-center gap-3 text-parchment/50 hover:text-white transition-colors text-xs font-bold uppercase tracking-widest">
                <SafeIcon icon={FiIcons.FiYoutube} /> Youtube
              </a>
              <a href="#" className="flex items-center gap-3 text-parchment/50 hover:text-white transition-colors text-xs font-bold uppercase tracking-widest">
                <SafeIcon icon={FiIcons.FiLinkedin} /> LinkedIn
              </a>
            </div>
          </div>

        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-8 text-[10px] text-parchment/30 font-bold uppercase tracking-[0.2em]">
          <div className="flex gap-8">
            <p>&copy; {new Date().getFullYear()} NomadCrate Systems Ltd.</p>
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
          </div>
          
          <p className="font-serif italic tracking-normal opacity-60 text-sm" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;